enum TypeRoles {
	Employee = 1,
	Owner = 2,
	NamespaceAdmin = 3,
	ProjectAdmin = 4,
	Microservice = 5
}
export default TypeRoles
